import {
    Alert,
    Box,
    FormControl,
    Grid,
    ThemeSpaceVariable,
    ToggleButton,
} from "@caspeco/casper-ui-library";
import { SafeHTML } from "components/safe-html";
// eslint-disable-next-line caspeco/discourage-chakra-import
import { InputGroup } from "@chakra-ui/react";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";

const EditGuests = ({
    setGuests,
    guests,
    availableGuestSizes = [],
}: {
    setGuests: (guests: number | null) => void;
    guests: number | null;
    availableGuestSizes: number[];
}) => {
    const externalBookingSettings = useExternalBookingSettings().data;
    const { maxWebGuests } = externalBookingSettings?.unitsMetaData ?? { maxWebGuests: 0 };

    return (
        <FormControl key="guest-choice" id="guestChoice">
            <InputGroup>
                <Grid templateColumns="repeat(4, 1fr)" gap={ThemeSpaceVariable.Medium} width="100%">
                    {[...Array(maxWebGuests + 1).keys()]
                        .map((n) => n + 1)
                        .map((guestsItem, i, arr) => {
                            const isLastItem = i === arr.length - 1;
                            const isPressed =
                                guests === guestsItem || (isLastItem && guests === null);
                            if (!availableGuestSizes.includes(guestsItem) && !isLastItem) {
                                return null;
                            }

                            return (
                                <ToggleButton
                                    key={guestsItem}
                                    size="lg"
                                    w="full"
                                    onClick={() => {
                                        if (guestsItem > maxWebGuests) {
                                            setGuests?.(null);
                                            return;
                                        }
                                        setGuests?.(guestsItem);
                                    }}
                                    h={ThemeSpaceVariable.XLarge}
                                    isPressed={isPressed}
                                >
                                    {guestsItem}
                                    {guestsItem === maxWebGuests + 1 && "+"}
                                </ToggleButton>
                            );
                        })}
                </Grid>
            </InputGroup>
            {!guests && (
                <Box mt={ThemeSpaceVariable.Medium}>
                    <Alert type="info" iconVerticalAlign={"flex-start"}>
                        <SafeHTML
                            className="textFromSettings"
                            element="div"
                            options={{
                                allowedTags: ["a", "br"],
                                allowedSchemes: ["tel", "mailto", "https"],
                            }}
                            html={
                                externalBookingSettings?.unitsMetaData.messageExceededGuests ?? ""
                            }
                        />
                    </Alert>
                </Box>
            )}
        </FormControl>
    );
};

export default EditGuests;
